module.exports = __webpack_public_path__ + "static/media/cms-logo.bf7dc12e.svg";